import { Component, ComponentFactoryResolver, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalTypes } from '../../models/IModalOptions';

@Component({
  selector: 'ff-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  // Modal title
  @Input() title: string;

  // Modal title align
  @Input() titleAlign: string = "left";

  // Type of the modal
  @Input() type: ModalTypes;

  // Content of the modal
  // Either an string or another component to render inside
  @Input() content?: any;

  // Primary button name and value
  @Input() primaryAction?: string;

  // Secondary button name and value
  @Input() secondaryAction?: string;

  //width of the modal
  @Input() width: number| string = 620;

  //width of the modal
  @Input() showHeader: boolean = true;

  //Padding of the modal
  @Input() padding: boolean = true;

  // Callback to return the selected value
  @Output() selection?: (value:string) => void;

  // A callback so the parent that created the instance removes it from the dom
  public clear?: () => void;

  // Template ref fot any child component content
  @ViewChild("child",{read: ViewContainerRef}) childContainer: ViewContainerRef;

  // Props to pass to the child component, if any
  public props?: {[prop:string]: any};

  constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit(): void {

    this.width = typeof(this.width) === 'string' ? this.width: this.width + 'px'
  }

  ngAfterViewInit(): void {
    if( this.isComponentContent() ) {
      this.childContainer.clear();

      const factory = this.componentFactoryResolver.resolveComponentFactory(this.content.component);
      const childRef = this.childContainer.createComponent(factory);

      if(this.content.props) {
        for(let prop in this.content.props) {
          childRef.instance[prop] = this.content.props[prop];
          childRef.instance["clear"] = this.clear;
        }
      }

      childRef.changeDetectorRef.detectChanges();
    }
  }

  // Secondary action, simple X button or click on background
  onDissmiss = (_:Event) => {
    this.close(this.secondaryAction);
  }

  // Primary button
  onAccept = (_:Event) => {
    this.close(this.primaryAction);
  }

  close(value:string): void {
    if( this.selection ) this.selection(value);
    if(this.clear) this.clear();
  }

  isTextualContent(): boolean {
    return this.content != undefined && typeof(this.content) === typeof('string');
  }

  isComponentContent(): boolean {
    return this.content != undefined && typeof(this.content) !=  typeof('string');
  }

  typeIcon(): string {
    const prefix = "../../../assets/icons";
    if(this.type === ModalTypes.Help)    return "icon-help";
    if(this.type === ModalTypes.Warning) return "icon-warn";
    if(this.type === ModalTypes.Error)   return "icon-error";
  }

}
